import { Dialog, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React, { useEffect, useState } from "react";
import { useReduxState } from "../../../../explorer/redux/hooks";
import { Basket } from "../../../../explorer/types";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";
import ServiceProvider from "../../../configuration/ServiceProvider";
import useBrands from "../../../../explorer/hooks/useBrands";
import { useBasket } from "../../../hook/useBasket";
import DrawerVolatileDialog from "../../../../explorer/components/Dialog/DrawerVolatileDialog";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { BasketUpload } from "./BasketUpload";
import { AppIconsCloseStyled, CloseIconWrapper, DialogContentStyled, StyledBox, StyledDialogTitle, StyledTypographyTitle } from "./BasketUploadPopup.style";
import {  } from "../../AppLayout/AppHeader/AppBasketMenu/BasketListDialog.style";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export type UploadBasketPopupProps = {
    open?: boolean;
    onClose: any;
    reloadPrice: any;
};
//

export const BasketUploadPopup = (props: UploadBasketPopupProps) => {
  const [
    basketActionResultSnackbarState,
    setBasketActionResultSnackbarState,
  ] = useState({ open: false, isError: false, message: "" });


  const [basketListState, setBasketListState] = useReduxState<Basket[]>(
      reduxStoreConfig.basketBaskets
  );
  const [loading, setLoading] = useState<boolean>(false);


  const [basketIdToBeMerged, setBasketIdToBeMerged] = useState("");

  const [mergingPopupOpen, setMergingPopupOpen] = useState(false);

  const basketHook = useBasket();
  
  const brand=useBrands().currentBrandUrl;
  const bastket = useBasket();


  useEffect(() => {
    let wW = window.innerWidth;  
    let wH =  window.innerHeight; 

    if (wH < 720) {
      setPopupW('90%');
      setPopupH('90%');
    }
  }, [props.open]);

  const handleClose = () => {
    props.onClose(false);
  };



  //warning dialog
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

  const [popoverMessage, setPopoverMessage] = React.useState<string | null>(
    null
  );

  const [popupH, setPopupH] = React.useState('730');
  const [popupW, setPopupW] = React.useState('1000');

  const {t} = useTranslation();
  return (
      <>
          <Dialog
              open={props.open != undefined && props.open}
              PaperProps={{ style: { maxHeight: "80%" } }}
              maxWidth={"md"}
              sx={{ "& .MuiDialog-paper": { maxHeight: 600, minHeight: 600 } }}
              keepMounted={true}
          >
              <StyledDialogTitle>
                  <StyledBox style={{}}>
                      <StyledTypographyTitle variant="subtitle1">
                          {t("basket.upload.popuo_title")}
                      </StyledTypographyTitle>
                      <CloseIconWrapper onClick={handleClose}>
                          <AppIconsCloseStyled />
                      </CloseIconWrapper>
                  </StyledBox>
              </StyledDialogTitle>

              {props.open && (
                  <BasketUpload
                      onClose={props.onClose}
                      reloadPrice={props.reloadPrice}
                      onSave={() => {
                          handleClose();
                      }}
                  />
              )}
          </Dialog>
      </>
  );
};

//Merge Basket
